import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import { FaGoogle } from 'react-icons/fa'; 
import { auth, googleProvider } from '../config/firebaseConfig';
import { signInWithPopup } from 'firebase/auth';

const GoogleSignIn = ({ onSuccess }) => {
  const handleGoogleSignIn = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      onSuccess(user); 
      alert(`Welcome, ${user.displayName}!`);
    } catch (error) {
      console.error('Google Sign-In Error:', error);
      alert('Failed to sign in with Google. Please try again.');
    }
  };

  return (
    <Button
      variant="contained"
      sx={{
        textTransform: 'none',
        fontWeight: 'bold',
        backgroundColor: '#000', 
        color: '#fff', 
        '&:hover': {
          backgroundColor: '#fff', 
          color: '#000', 
          border: '1px solid #000', 
        },
        display: 'flex',
        alignItems: 'center', 
        gap: 1, 
      }}
      onClick={handleGoogleSignIn}
    >
      {/* Google Logo Icon */}
      <Box sx={{ fontSize: 20 }}>
        <FaGoogle />
      </Box>

      {/* Text */}
      <Typography>Sign in with Google</Typography>
    </Button>
  );
};

export default GoogleSignIn;
